import { telephoneNumbers } from '@agria/theme/src/const/telephoneNumbers';
import { myAccountLinks } from './myAccountLinks';
import { NavItem } from '../types/types';
import { ctaButtons } from './ctaButtons';
import { myAccountConfig } from './myAccountConfig';

//
// CUSTOMERS
//

export const customerLinks: NavItem[] = [
  {
    label: 'Home',
    url: myAccountLinks.dashboard,
    ctaOverride: ctaButtons.customer,
  },
  {
    label: 'My pets',
    url: myAccountLinks.myPets,
    partiallyActive: true,
    ctaOverride: ctaButtons.customer,
  },
  {
    label: 'My claims',
    url: myAccountLinks.myClaims,
    ctaOverride: ctaButtons.customer,
  },
  {
    label: 'Document hub',
    partiallyActive: true,
    url: myAccountLinks.documentHub,
    ctaOverride: ctaButtons.customer,
  },
  {
    label: 'My details',
    url: myAccountLinks.myDetails,
    ctaOverride: ctaButtons.customer,
  },
  {
    label: 'Your rewards',
    url: myAccountLinks.myRewards,
    ctaOverride: ctaButtons.customer,
  },
  {
    label: 'Agria app',
    url: myAccountLinks.vetGuide,
    ctaOverride: ctaButtons.customer,
  },
  {
    label: 'Inclusive benefits',
    url: myAccountLinks.inclusiveBenefits,
    ctaOverride: ctaButtons.customer,
  },
  {
    label: 'Refer a friend',
    url: myAccountLinks.referAFriend,
    ctaOverride: ctaButtons.customer,
  },
  {
    label: 'Help and contact',
    url: myAccountLinks.helpAndContact,
    ctaOverride: ctaButtons.customer,
  },
];

//
// VETS
//

const vetOverides = {
  ctaOverride: ctaButtons.vets,
  telephoneNumberOverride: telephoneNumbers.vetSupport,
};

export const vetLinks: NavItem[] = [
  {
    label: 'Home',
    url: myAccountLinks.dashboard,
    ...vetOverides,
  },
  {
    label: '5 weeks free cover',
    url: myAccountLinks.freeCover,
    ...vetOverides,
  },
  {
    label: 'Claims',
    url: myAccountLinks.claims,
    ...vetOverides,
  },
  {
    label: 'Your reward statement',
    url: myAccountLinks.rewardStatement,
    ...vetOverides,
  },
  {
    label: 'Your rewards',
    url: myAccountLinks.myRewards,
    ...vetOverides,
  },
  ...(myAccountConfig.enableMarketingMaterials
    ? [
        {
          label: 'Marketing materials',
          url: myAccountLinks.marketingMaterials,
          ...vetOverides,
        },
      ]
    : []),
  {
    label: 'Your Details',
    url: myAccountLinks.myDetails,
    ...vetOverides,
  },
  {
    label: 'Help and contact',
    url: myAccountLinks.helpAndContact,
    ...vetOverides,
  },
];

export const nonAffiliateVetLinks: NavItem[] = [
  {
    label: 'Home',
    url: myAccountLinks.dashboard,
  },
  {
    label: 'Claims',
    url: myAccountLinks.claims,
  },
  {
    label: 'Your reward statement',
    url: myAccountLinks.rewardStatement,
  },
  {
    label: 'Your details',
    url: myAccountLinks.myDetails,
  },
  {
    label: 'Help and contact',
    url: myAccountLinks.helpAndContact,
  },
];

//
// BREEDERS
//

export const breederLinks: NavItem[] = [
  {
    label: 'Home',
    url: myAccountLinks.dashboard,
    ctaOverride: ctaButtons.breeder,
  },
  {
    label: '5 weeks free cover',
    url: myAccountLinks.freeCover,
    ctaOverride: ctaButtons.breeder,
  },
  {
    label: 'Add a litter',
    url: myAccountLinks.addALitter,
    ctaOverride: ctaButtons.breeder,
  },
  {
    label: 'Your reward statement',
    url: myAccountLinks.rewardStatement,
    ctaOverride: ctaButtons.breeder,
  },
  {
    label: 'Breeder Club Essentials',
    url: myAccountLinks.breederClubEssentials,
    ctaOverride: ctaButtons.breeder,
  },
  {
    label: 'My details',
    url: myAccountLinks.myDetails,
    ctaOverride: ctaButtons.breeder,
  },
  {
    label: 'Help and contact',
    url: myAccountLinks.helpAndContact,
    ctaOverride: ctaButtons.breeder,
  },
];

//
// REHOMING (charities)
//

const rehomingOverides = {
  ctaOverride: ctaButtons.rehoming,
  telephoneNumberOverride: telephoneNumbers.rehomngSupport,
};

export const rehomingLinks: NavItem[] = [
  {
    label: 'Home',
    url: myAccountLinks.dashboard,
    ...rehomingOverides,
  },
  {
    label: '5 weeks free cover',
    url: myAccountLinks.freeCover,
    ...rehomingOverides,
  },
  {
    label: 'Your reward statement',
    url: myAccountLinks.rewardStatement,
    ...rehomingOverides,
  },
  {
    label: 'Your rewards',
    url: myAccountLinks.myRewards,
    ...rehomingOverides,
  },
  ...(myAccountConfig.enableMarketingMaterials
    ? [
        {
          label: 'Marketing materials',
          url: myAccountLinks.marketingMaterials,
          ...rehomingOverides,
        },
      ]
    : []),
  {
    label: 'Your details',
    url: myAccountLinks.myDetails,
    ...rehomingOverides,
  },
  {
    label: 'Help and contact',
    url: myAccountLinks.helpAndContact,
    ...rehomingOverides,
  },
];
